import React from 'react';
import styled from '@emotion/styled';
import ArrowIcon from '../../../../public/static/arrow.svg';
import { IArrowProps } from './arrow';

type IArrowSize = { [key in Required<IArrowProps>['size']]: { heigth: string; width: string } };
type IArrowOrientation = { [key in Required<IArrowProps>['orientation']]: string };

const arrowSize: IArrowSize = {
    S: { heigth: '10px', width: '8px' },
    M: { heigth: '18px', width: '14px' },
    L: { heigth: '37px', width: '19px' },
};

const arrowOrientation: IArrowOrientation = {
    left: 'scale(-1)',
    up: 'rotate(-90deg)',
    down: 'rotate(90deg)',
    right: 'rotate(0)',
};

export const StyledArrow = styled(ArrowIcon)<IArrowProps>`
    height: ${(props) => arrowSize[props.size || 'M'].heigth};
    width: ${(props) => arrowSize[props.size || 'M'].width};
    path {
        height: ${(props) => arrowSize[props.size || 'M'].heigth};
        width: ${(props) => arrowSize[props.size || 'M'].width};
    }
    transform: ${(props) => arrowOrientation[props.orientation || 'right']};
    fill: ${(props) => props.theme.icon.brandColor1};
    z-index: 1;
`;
